import { useParams, useRouter } from '@tanstack/react-router'

export const useGetSafeClientCode = () => {
    const router = useRouter()
    const isRoot = useIsRootPage()
    const isInvitePage = useIsInvitePage()
    const { client_code } = useParams({
        from: '/_authed/$client_code/',
    })

    if ((!client_code || client_code === '') && !isRoot && !isInvitePage) {
        router.history.push('/')
    }

    return client_code
}

export const useIsInvitePage = () => {
    const router = useRouter()
    const currentPath = (router as any).state.location.pathname

    return currentPath.includes('/invite/')
}

export const useIsRootPage = () => {
    const router = useRouter()
    return (router as any).state.location.pathname === '/'
}
